import { jsx as _jsx } from "react/jsx-runtime";
import { BroadcastOutlinedIcon, MessageDotsFilledIcon, MessageDotsOutlinedIcon, MessageFilledIcon, PersonFilledIcon, PersonOutlinedIcon, VoipFilledIcon, } from '@getgo/chameleon-icons/react';
import parsePhoneNumberFromString from 'libphonenumber-js';
import { TEAM_GOTO_PHONE_NUMBERS } from "../utils/teamGoToPhoneNumbers";
import { fullName } from "../utils/user";
export var AgentCallPendingActions;
(function (AgentCallPendingActions) {
    AgentCallPendingActions[AgentCallPendingActions["NONE"] = 0] = "NONE";
    AgentCallPendingActions[AgentCallPendingActions["ACCEPT"] = 1] = "ACCEPT";
    AgentCallPendingActions[AgentCallPendingActions["DECLINE"] = 2] = "DECLINE";
    AgentCallPendingActions[AgentCallPendingActions["END_ACCEPT"] = 3] = "END_ACCEPT";
    AgentCallPendingActions[AgentCallPendingActions["HOLD_ACCEPT"] = 4] = "HOLD_ACCEPT";
    AgentCallPendingActions[AgentCallPendingActions["STOP_WRAPUP"] = 5] = "STOP_WRAPUP";
})(AgentCallPendingActions || (AgentCallPendingActions = {}));
export var WebChatCustomIcon;
(function (WebChatCustomIcon) {
    WebChatCustomIcon["SVG_VOIP"] = "SVG_VOIP";
    WebChatCustomIcon["SVG_PERSON_ACTIVE"] = "SVG_PERSON_ACTIVE";
    WebChatCustomIcon["SVG_PERSON_INACTIVE"] = "SVG_PERSON_INACTIVE";
    WebChatCustomIcon["SVG_CHAT_DOTS_INACTIVE"] = "SVG_CHAT_DOTS_INACTIVE";
    WebChatCustomIcon["SVG_CHAT_DOTS_ACTIVE"] = "SVG_CHAT_DOTS_ACTIVE";
    WebChatCustomIcon["SVG_CHAT_ACTIVE"] = "SVG_CHAT_ACTIVE";
    WebChatCustomIcon["SVG_BROADCAST"] = "SVG_BROADCAST";
})(WebChatCustomIcon || (WebChatCustomIcon = {}));
export const webChatIcons = {
    [WebChatCustomIcon.SVG_VOIP]: function Icon(props) {
        return _jsx(VoipFilledIcon, Object.assign({}, props), void 0);
    },
    [WebChatCustomIcon.SVG_PERSON_ACTIVE]: function Icon(props) {
        return _jsx(PersonFilledIcon, Object.assign({}, props), void 0);
    },
    [WebChatCustomIcon.SVG_PERSON_INACTIVE]: function Icon(props) {
        return _jsx(PersonOutlinedIcon, Object.assign({}, props), void 0);
    },
    [WebChatCustomIcon.SVG_CHAT_DOTS_INACTIVE]: function Icon(props) {
        return _jsx(MessageDotsOutlinedIcon, Object.assign({}, props), void 0);
    },
    [WebChatCustomIcon.SVG_CHAT_DOTS_ACTIVE]: function Icon(props) {
        return _jsx(MessageDotsFilledIcon, Object.assign({}, props), void 0);
    },
    [WebChatCustomIcon.SVG_CHAT_ACTIVE]: function Icon(props) {
        return _jsx(MessageFilledIcon, Object.assign({}, props), void 0);
    },
    [WebChatCustomIcon.SVG_BROADCAST]: function Icon(props) {
        return _jsx(BroadcastOutlinedIcon, Object.assign({}, props), void 0);
    },
};
export const getCallDurationLabel = (date, dateNow, inverse) => {
    let durationLabel = '0:00';
    if (date) {
        const timeMilliseconds = date.getTime();
        let totalSeconds = 0;
        if (inverse) {
            totalSeconds =
                dateNow <= timeMilliseconds ? Math.floor((timeMilliseconds - dateNow) / 1000) : 0;
        }
        else {
            totalSeconds =
                dateNow >= timeMilliseconds ? Math.floor((dateNow - timeMilliseconds) / 1000) : 0;
        }
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds - hours * 3600) / 60);
        const seconds = totalSeconds % 60;
        durationLabel =
            (hours >= 1 ? hours + '' + ':' : '') +
                (minutes >= 1 ? (minutes + '').padStart(hours >= 1 ? 2 : 1, '0') : '0') +
                ':' +
                (seconds + '').padStart(2, '0');
    }
    return durationLabel;
};
export const formatDuration = (durationSeconds) => {
    const minutes = Math.floor(durationSeconds / 60);
    const seconds = Math.floor(durationSeconds % 60);
    return `${minutes}:${(seconds + '').padStart(2, '0')}`;
};
export const getParticipantName = (user, isUnlinkedConversation = false) => {
    if (isUnlinkedConversation &&
        (user === null || user === void 0 ? void 0 : user.phoneNumber) &&
        TEAM_GOTO_PHONE_NUMBERS.includes(user === null || user === void 0 ? void 0 : user.phoneNumber)) {
        return 'Team GoTo';
    }
    let name = fullName(user);
    if (!name && (user === null || user === void 0 ? void 0 : user.phoneNumber)) {
        name = formatPhoneNumber(user.phoneNumber);
    }
    else if (!name && (user === null || user === void 0 ? void 0 : user.email)) {
        name = user.email;
    }
    return name !== null && name !== void 0 ? name : '';
};
export const formatPhoneNumber = (number) => { var _a, _b; return (_b = (_a = parsePhoneNumberFromString(number !== null && number !== void 0 ? number : '')) === null || _a === void 0 ? void 0 : _a.formatInternational()) !== null && _b !== void 0 ? _b : number; };
export const getCallSipCallId = (agentActiveCall) => { var _a; return agentActiveCall ? (_a = agentActiveCall.connections.find(conn => !!conn.sipCallId)) === null || _a === void 0 ? void 0 : _a.sipCallId : null; };
//# sourceMappingURL=helpers.js.map